var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 35,
    viewBox: "0 0 27 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4315 34.094C13.0419 35.0318 14.4661 35.0318 15.0765 34.094C24.9785 20.027 26.8097 18.5533 26.8097 13.3284C26.8097 6.22794 20.977 0.467163 13.7879 0.467163C6.53098 0.467163 0.766113 6.22794 0.766113 13.3284C0.766113 18.5533 2.52948 20.027 12.4315 34.094ZM13.7879 18.6873C10.7359 18.6873 8.36217 16.3428 8.36217 13.3284C8.36217 10.3811 10.7359 7.96957 13.7879 7.96957C16.7721 7.96957 19.2137 10.3811 19.2137 13.3284C19.2137 16.3428 16.7721 18.6873 13.7879 18.6873Z",
    fill: "#1D2A30"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pin.dd7aff8b.svg";
export { ForwardRef as ReactComponent };